import { gql } from "@apollo/client";
import { ImageFragment } from "../../fragments/image";

export const QUERY_MENU = gql`
  query QueryMenu {
    globalMenu {
      data {
        attributes {
          logo {
            data {
              ...ImageFragment
            }
          }
          mobileLogo {
            data {
              ...ImageFragment
            }
          }
          links {
            text
            url
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
